import { render, staticRenderFns } from "./UserLearnProgressPage.vue?vue&type=template&id=2a736772&scoped=true"
import script from "./UserLearnProgressPage.vue?vue&type=script&lang=js"
export * from "./UserLearnProgressPage.vue?vue&type=script&lang=js"
import style0 from "./UserLearnProgressPage.vue?vue&type=style&index=0&id=2a736772&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a736772",
  null
  
)

export default component.exports